// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#split_image[data-v-a3c681ac] {\n  max-width: 8rem;\n}", ""]);
// Exports
module.exports = exports;
